import { render, staticRenderFns } from "./AssembleWiki.vue?vue&type=template&id=cc118f62&scoped=true&"
import script from "./AssembleWiki.vue?vue&type=script&lang=ts&"
export * from "./AssembleWiki.vue?vue&type=script&lang=ts&"
import style0 from "./AssembleWiki.vue?vue&type=style&index=0&id=cc118f62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc118f62",
  null
  
)

export default component.exports